import React from "react"
import { UserIcon } from "../../../../../../components/parts/user-icon"
import { IconSize } from "../../../../../../components/templates/chat/style"
import { JSONRPCErrorCatch } from "../../../../../../error/error"
import { NotificationActionDispatcher } from "../../../../../../libs/notifications"
import { JSONRPCClientBuilder } from "../../../../../../request/JSONRPCClientBuilder"
import { EpisodeRPC } from "../../../../../../rpcs/dist/EpisodeRPC"
import { User } from "../../../../../../rpcs/dist/UserRPC"
import styled from "styled-components"
import Color from "../../../../../../style/enum/color"
import {
  ChangeIconButton,
  IImageData,
} from "../../../../../../components/parts/buttons/change-icon-button"
import { IContainerProps } from "../../../../container"

interface IProps {
  displayId: string
  anonymousUser: User
  actions: IContainerProps["actions"]
}

export const AnonymousUser = (props: IProps) => {
  const updateAnonymousUser = async (imageData: IImageData) => {
    NotificationActionDispatcher.LogNotification(
      "ゲストユーザーのプロフィールを更新してます",
    )

    const rpcUser = JSONRPCClientBuilder.build(EpisodeRPC)
    const res = await rpcUser
      .overwriteAnonymousUserInfo({
        displayId: props.displayId,
        user: {
          id: props.anonymousUser.id,
          profileImage: imageData,
        },
      })
      .catch(JSONRPCErrorCatch)

    if (res !== -1) {
      props.actions.updateAnonymousUser({
        ...props.anonymousUser,
        ...res,
      })

      NotificationActionDispatcher.SuccessNotification(
        "ゲストユーザーのプロフィールを更新しました",
      )
    }
  }

  return (
    <StyledItem key={props.anonymousUser.id}>
      <UserIcon
        size={IconSize}
        title={"ユーザー"}
        url={props.anonymousUser.profileImage.square}
      />
      <Name>{props.anonymousUser.screenName}</Name>
      <ChangeIconButton receiveImageData={updateAnonymousUser} />
    </StyledItem>
  )
}

const StyledItem = styled.li`
  display: flex;
  align-items: center;
  padding: 10px 0;
  & + & {
    border-top: 1px solid ${Color.THIN_GRAY};
  }
`

const Name = styled.div`
  margin-left: 10px;
  flex-grow: 10;
`
